import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionRoute, editReportVersionScopeRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { ReportVersionStatus, useReportVersionScopeQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { EditReportScopeForm } from "app/component/report-scope/EditReportScopeForm";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const EditReportVersionScopeScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(editReportVersionScopeRoute);
    const [updated, setUpdated] = useState(false);
    const { data, loading, error } = useReportVersionScopeQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const scope = data?.reportVersion?.scope;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!scope) {
        return <ErrorScreen title="Error" message="Not found" />;
    }
    if (data?.reportVersion?.status !== ReportVersionStatus.Scoping) {
        return <ErrorScreen title="Error" message="This section may only be edited during the scoping status." />;
    }

    return updated ? (
        <Navigate to={editReportVersionRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionScopeRoute} />
                <EditReportScopeForm scopeId={scope._id} onUpdate={() => setUpdated(true)} />
            </Container>
        </NavigationScreen>
    );
};
